import React, { memo, useEffect } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { useGoToLevel, usePagination, useCheckpoint } from 'src/hooks';

import {
  MenuFrame,
  PageLoader,
  ContentContainer,
  Navbar,
  Image,
} from 'src/components/common';

import './index.scss';
import { video, checkpoints } from 'src/constants';

const Container = ({
  className,
  currency,
  getCollections,
  hasLoaded,
  items,
  levelsPath,
  title,
}) => {
  const goToLevel = useGoToLevel(levelsPath);

  const {
    currentPage,
    pageCount,
    handlePreviousPage,
    handleNextPage,
    pageItems,
  } = usePagination(items);

  useEffect(() => {
    getCollections();
  }, [getCollections]);

  useCheckpoint(checkpoints.FIRST_TIME_ON_FIND_WORDS, hasLoaded);

  if (!hasLoaded) {
    return <PageLoader />;
  }

  return (
    <PageLoader isFadingOut>
      <Navbar.GameNavbar
        currency={currency}
        title={title}
        videoName={video.NAME.FIND_WORDS}
      />
      <div className={cn('find-words-collections-container', className)}>
        <MenuFrame
          title={title}
          currencyImageUrl={currency.imageUrl}
          currentPageNumber={currentPage}
          pagesCount={pageCount}
          onBack={handlePreviousPage}
          onForward={handleNextPage}
        >
          <div className="find-words-collections-container__collections">
            {pageItems?.map((collection) => (
              <ContentContainer
                variant="small"
                onClick={() => goToLevel(collection.id)}
                isLocked={collection.isLocked}
                showFeedback={collection.showFeedback}
                isFeedbackPositive={collection.isFeedbackPositive}
              >
                <p>{collection.label}</p>
                <Image alt={collection.key} src={collection.imageUrl} />
              </ContentContainer>
            ))}
          </div>
        </MenuFrame>
      </div>
    </PageLoader>
  );
};

Container.propTypes = {
  className: PropTypes.string.isRequired,
  currency: PropTypes.shape({
    imageUrl: PropTypes.string,
  }).isRequired,
  getCollections: PropTypes.func.isRequired,
  hasLoaded: PropTypes.bool.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  levelsPath: PropTypes.string.isRequired,
  student: PropTypes.shape({
    hasPassedFindWordsEducation: PropTypes.bool.isRequired,
  }).isRequired,
  title: PropTypes.string.isRequired,
};

export default memo(Container);
